import { AllPlantCapacityResponse, PlantCapacityDto } from '@gtpl/shared-models/planning';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantCapacityDTO } from './dto/plant-capacity-dto.';
import { PlantCapacitiesRequest } from './dto/plant-capacity-request';
import { PlantCapacityRequest } from './dto/plant-capacity.request';
import { PlantCapacityService } from './plant-capacity.service';
@ApiTags('plant-capacity')
@Controller('plant-capacity')
export class PlantCapacityController {
    constructor(
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
        private plantCapacityService: PlantCapacityService
    
    ){}
    @Post('/createPlantCapacity')
    async createPlantCapacity(@Body() plantCapacityReq: PlantCapacityDTO[],isUpdate:boolean=false): Promise<AllPlantCapacityResponse> {
    try {
        return await this.plantCapacityService.createPlantCapacity(plantCapacityReq, false);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(AllPlantCapacityResponse, error);
        // return error;
        }
    }
    @Post('/getCapacityByPlant')
  async getCapacityByPlant(@Body() request: PlantCapacitiesRequest): Promise<AllPlantCapacityResponse> {
      try {
          return await this.plantCapacityService.getCapacityByPlant(request);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllPlantCapacityResponse, error)
      }
  }
  @Post('/updatePlantCapacity')
    async updatePlantCapacity(@Body() plantCapacityReq: PlantCapacityDTO[]): Promise<AllPlantCapacityResponse> {
      try {
        console.log('update AllPlantCapacityResponse');
        return await this.plantCapacityService.createPlantCapacity(plantCapacityReq, true);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(AllPlantCapacityResponse, error);
      }
  }
}
